import { CustomWindow } from 'pages/leadGen/LeadGenInterface';
import { INPUT_TYPE } from './TradeInConstant';
import { BBQuestion, Flowtype, TransformedQuestion } from './TradeInInterface';
import { FieldValues } from 'react-hook-form';

export function transformQuestions(questions: BBQuestion[]): TransformedQuestion[] {
  return questions.map((question) => ({
    id: question.questionid,
    label: question.questionText, // Use localization function if needed
    labelTxt: question.questionText,
    required: question.required,
    type: INPUT_TYPE[question.inputType],
    options: question.answers.map((answer) => ({
      value: answer.answerCode,
      label: answer.answerText,
    })),
  }));
}

export function formatWithCommaSeparator(value: number | string): string {
  try {
    if (typeof value === 'string') {
      value = parseFloat(value);
      if (isNaN(value)) {
        throw new Error('Invalid number string');
      }
    }

    return value.toLocaleString('en-US');
  } catch (error) {
    console.error('Error in formatWithCommaSeparator', error);
    return '';
  }
}

export const displayKeyPointers = (answersArray: any, questionsArray: any) => {
  return answersArray
    .map((answer) => {
      const question = questionsArray.find((q) => q.questionid === answer.questionId);
      if (question) {
        const selectedAnswer = question.answers.find((ans: any) => ans.answerCode === answer.actualAnswer);
        return { keyTxt: selectedAnswer?.keyTxt, ans: answer.actualAnswer, actualAnsTxt: answer.actualAnswerTxt };
      }
      return null;
    })
    .filter(Boolean); // Filter out null values
};

export const sendWindowDataLayer = (formData: FieldValues) => {
  (window as CustomWindow).dataLayer = (window as CustomWindow).dataLayer || [];

  (window as CustomWindow)?.dataLayer?.push({
    event: 'Lead_Submission',
    customData: 'Lead Submitted Successfully',
    enhanced_conversion_data: {
      email: formData.email,
      phone_number: `+${formData.phone}`,
      first_name: formData.firstName,
      last_name: formData.lastName,
      street: formData.streetAddress,
      city: formData.city,
      region: formData.city,
      postal_code: formData.postalCode,
      country: formData.country,
    },
  });
};

export const sendEventToParent = (eventType: string, data: any) => {
  window.parent.postMessage({ eventType, data }, '*');
};

export const mapIsMobileToFlowtype = (isMobile: boolean): Flowtype => {
  return isMobile ? Flowtype.MOBILE : Flowtype.DESKTOP;
};
